export const GRAY = '#BFBFBF';
